// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__O40x3","container":"styles_container__2qDO2","title":"styles_title__CDaVR","wrapper":"styles_wrapper__3slwM","answer":"styles_answer__3-oJX"};